// API 基础地址，根据构建环境自动切换
// 去除末尾斜杠，保证拼接路径时不会出现双斜杠
export const API_BASE_URL = (process.env.VUE_APP_API_BASE_URL || '').replace(/\/$/, '');
